<template>
  <div class="Comment-List-box">
	 <div class="list_box" v-if="list && list.length != 0">
	   <div class="list_item" v-for="(item, index) in list" :key="index" @click="view_details(item)">
			<div class="information_box">
			 	<div class="avatar" @click.stop="check_information(item)">
			 		<img v-if="item.like_user_avatar && item.like_user_avatar != ''" :src="item.like_user_avatar" :alt="'TOZO Community ' + item.like_user_name + ' User Avatar'"/>
			 		<i v-else class="el-icon-s-custom"></i>
			 	</div>
			</div>
			<div class="right_box">
				<div class="name_box" @click.stop="check_information(item)">
					<div class="name">{{ item.like_user_name }}</div>
					<div class="release_time">{{ $fun.formatTime(item.like_date) }}</div>
				</div>
				<div class="content_box_big">
					<div class="Comment_content_list" v-if="item.content_list">
						<div class="content_item" v-for="(item_con, index_con) in item.content_list" :key="index_con">
							<div v-if="!item_con.name" class="comment_you_title">{{ $t('MessagesArr.Comment_you') }}<span class="colon">:</span> </div>
							<div v-else class="name">{{ item_con.name }}<span class="colon">:</span></div>
							<div class="content_text" v-html="item.my_cmt">{{ item.reply_cmt }}</div>
						</div>
					</div>
					<!-- <div class="reply_cmt">{{ item.reply_cmt }}</div> -->
					<div class="reply_cmt Liked_your" :class="item.post_id ? 'pointer' : 'no_drop' " @click.stop="reply_cmt(item)">{{ item.comment_content ? $t('MessagesArr.Liked_your_comment') : $t('MessagesArr.Liked_your_post') }}</div>
					
					<div class="Post_box" v-if="item.comment_content || item.content" :class="item.post_id ? 'pointer' : 'no_drop'"  @click.stop="view_details(item)">
						<div class="Post_thumbnail" v-if="item.img">
							<img src="../../assets/icon/banner-web.jpg" alt="TOZO thumb img"/>
						</div>
						<div class="content_box">
							<!-- <div class="comment_you_title">
								{{ $t('MessagesArr.Comment_you') }}
								<span class="colon">:</span>
							</div> -->
							<!-- 评论内容或者帖子内容 -->
							<div class="comment_you_content">
								{{ item.comment_content ? item.comment_content : item.content }} 
							</div>
						</div>
					</div>
					<!-- <Swiper :item="item" :key="'swiper-' + item.id"></Swiper> -->
				</div>
			</div>
	   </div>
	 </div>
	 
	 <NoData v-else :calling_modules="calling_modules"></NoData>
  </div>
</template>

<script>
// import Swiper from './Swiper.vue'

export default {
	name: 'likes-module',
	// components: { Swiper },

	props: {
		comment_list: {
			type: Array,
			default: []
		},
		parent_type: {
			type: String,
			default: []
		},
		follow_button: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			calling_modules: "likes-module",
			list:[]
		}
	},
	
	// 监听
	watch: {
		"comment_list": {
			handler: function (newValue, oldValue) {
				// this.list = this.comment_list
			},
			deep: true
		},
	},
	
	// beforeCreate() {
		
	// }
	
  created () {
	  
  },
  
  mounted() {
	  this.list = this.comment_list
  },
  
  methods:{
	  //查看 粉丝或关注人信息
	  check_information(item){
		  console.log(item)
	  	let routeParams = {
	  		name: this.$store.state.userinfo.user_id == item.like_user_id ? "user-profile" : "users",
	  	   params: {
	  	      user_id: item.like_user_id,
	  	      nickname: item.nickname,
	  	   }
	  	};
	  	if (this.$route.name === 'home') {
	  		routeParams.params.previous = "posts-list";
	  	}else if (this.$route.name === 'users') {
	  		routeParams.name = "user-post-details"
	  		let path = this.$router.currentRoute.path
	  		let previous = path ? path.split("/")[1] : ''
	  		routeParams.params.previous = previous;
	  		
	  		let user = path ? path.split("/")[2] : ''
	  		if(user){
	  			routeParams.params.user = user;
	  		}
	  	}else{
	  		let path = this.$router.currentRoute.path
	  		let previous = path ? path.split("/")[1] : ''
	  		routeParams.params.previous = previous;
	  	}
	  	this.$router.push(routeParams);
	},
	// //查看 粉丝或关注人信息
	// check_information(item){
	// 	// this.$emit("close_bulletFrame_fun")
	// 	console.log(item)
	// 	this.$router.push({
	// 		name: this.$store.state.userinfo.user_id == item.like_user_id ? "user-profile" : "users",
	// 		params: {
	// 			user_id: item.like_user_id,
	// 			nickname: item.nickname,
	// 		}
	// 	})
	// },
	
	change_more(item){
		console.log(item)
	},
	
	//查看帖子详情详情
	view_details(item){
		console.log(item)
		if(this.$route.name.includes('post-details')){ return }
		
		let routeParams = {
		   name: "post-details",
		   params: {
		      post_id: item.post_id,
		      post_content: item.content,
		   }
		};
		if (this.$route.name === 'home') {
			routeParams.params.previous = "posts-list";
		}else if (this.$route.name === 'users') {
			routeParams.name = "user-post-details"
			let path = this.$router.currentRoute.path
			let previous = path ? path.split("/")[1] : ''
			routeParams.params.previous = previous;
			
			let user = path ? path.split("/")[2] : ''
			if(user){
				routeParams.params.user = user;
			}
		}else{
			let path = this.$router.currentRoute.path
			let previous = path ? path.split("/")[1] : ''
			routeParams.params.previous = previous;
		}
		this.$router.push(routeParams);
	},
	
	//查看帖子详情
	// view_details(item){
	// 	console.log(item)
	// 	if(!item.post_id){ return }
	// 	this.$router.push({
	// 		name: "PostDetails",
	// 		params: {
	// 			post_id: item.post_id,
	// 		}
	// 	})
	// },
	
	
	// 查看回复详情
	reply_cmt(item){
		console.log(item)
		if(!item.post_id){ return }
		this.view_details(item)
		// this.$router.push({
		// 	name: "PostDetails",
		// 	params: {
		// 		post_id: item.post_id,
		// 	}
		// })
		
		// console.log(item)
		// this.contentBoxData = {
		// 	user_id: item.reply_user_id,
		// 	avatar: item.reply_user_avatar,
		// 	nickname: item.reply_user_name,
		// 	public_time: item.reply_date,
		// 	content: item.reply_cmt,
		// 	comment_id: item.comment_id,
		// 	type: "reply_to_comments"
		// } 
		
	},
	
	//更新当前状态
	change_state(item){
		if(this.parent_type == 'follow'){
			this.change_RightSidebar(item)
		}else if(this.parent_type == 'fans-list'){
			this.change_FanHomePage(item)
		}else if(this.parent_type == 'follow-list'){
			this.change_FollowList(item)
		}
	},
	
	//更新当前状态
	change_RightSidebar(item){
		console.log('change_RightSidebar')	
		console.log(item)	
	},
	
	//更新当前状态
	change_FanHomePage(item){
		console.log('change_FanHomePage')	
		console.log(item)	
	},
	
	//更新当前状态
	change_FollowList(item){
		console.log('change_FollowList')	
		console.log(item)	
	}
	
  }
}
</script>

<style lang="less" scoped>
	*{
		box-sizing: border-box;
		font-family: Poppins, Poppins;
	}
	.Comment-List-box {
		width: 100%;
	}
	.list_box{
		/* margin-top: 26px; */
		.title{
			font-weight: 400;
			padding: 0px 10px;
			font-size: 15px;
			color: #000000;
			line-height: 18px;
			text-align: left;
			font-style: normal;
			text-transform: none;
		}
		.list_item{
			cursor: default;
			margin-top: 10px;
			display: flex;
			background-color: #ffffff;
			border-radius: 8px;
			display: flex;
			justify-content: space-between;
			.information_box{
				display: flex;
				.avatar{
					width: 40px;
					height: 40px;
					display: flex;
					justify-content: center;
					align-items: center;
					color: #505050;
					border-radius: 50%;
					overflow: hidden;
					cursor: pointer;
					img{
						width: 100%;
						height: 100%;
					}
					.el-icon-s-custom{
						height: 40px;
						display: flex;
						justify-content: center;
						align-items: center;
						width: 100%;
						height: 100%;
						display: flex;
						justify-content: center;
						align-items: center;
						border: 1px #f5f5f5 solid;
						border-radius: 50%;
						font-size: 20px;
						color: #999;
					}
				}
			}
			.right_box{
				width: calc(100% - 50px);
				.name_box{
					width: 100%;
					height: 40px;
					display: flex;
				}
				.name{
					font-weight: 400;
					color: #3C3C3C;
					text-align: left;
					font-style: normal;
					text-transform: none;
					white-space: nowrap; 
					overflow: hidden; 
					text-overflow: ellipsis;
				}
				.release_time{
					font-weight: 400;
					font-size: 10px;
					color: #666666;
					// color: #B3B3B3;
					line-height: 1;
					text-align: left;
					font-style: normal;
					text-transform: none;
				}
			}
			
			.content_box_big{
				width: 100%;
				margin-top: 15px;
				display: flex;
				flex-direction: column;
				.Comment_content_list{
					width: 100%;
					.content_item{
						display: flex;
						.name,
						.content_text{
							font-weight: 400;
							font-size: 15px;
							color: #3C3C3C;
							line-height: 24px;
							text-align: left;
							font-style: normal;
							text-transform: none;
						}
					}
				}
				.reply_cmt{
					display: flex
				}
				.Liked_your{
					color: #06f;
					// color: #2094FA;
				}
				.Post_box{
					margin-top: 15px;
					display: flex;
					width: 100%;
					background: #F5F5F5;
					border-radius: 8px;
					overflow: hidden;
				}
				.Post_thumbnail{
					width: 72px;
					height: 72px;
					img{
						width: 100%;
						height: 100%;
						object-fit: cover;
					}
				}
				.content_box{
					width: calc(100% - 82px);
					margin-left: 10px;
					padding: 10px 10px 10px 0px;
					display: flex;
					justify-content: center;
					flex-direction: column;
					.comment_you_content{
						width: 100%;
						/* margin-top: 5px; */
						font-weight: 400;
						font-size: 14px;
						color: #3C3C3C;
						line-height: 24px;
						text-align: left;
						font-style: normal;
						text-transform: none;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}
				}
				.comment_you_title{
					cursor: pointer;
					font-weight: 400;
					font-size: 15px;
					color: #4285F4;
					line-height: 24px;
					text-align: left;
					font-style: normal;
					text-transform: none;
				}
			}
			.colon{
				margin: 0px 5px;
			}
		}
	}
	
	.pointer{
		cursor: pointer;
	}
	.no_drop{
		cursor: no-drop;
	}
	@media screen and (min-width: 600px) {
		.list_item{
			cursor: pointer;
			margin-top: 10px;
			display: flex;
			padding: 18px 16px;
		}
		.name_box{
			width: 100%;
			height: 40px;
			display: flex;
			align-items: center;
			cursor: pointer;
			.name{
				font-size: 16px;
				line-height: 1.3;
			}
		}
		
		.release_time{
			margin-left: 30px;
		}
	}
	@media screen and (max-width: 600px) {
		.list_item{
			cursor: pointer;
			margin-top: 10px;
			display: flex;
			padding: 10px 10px;
		}
		.name_box{
			width: 100%;
			height: 40px;
			flex-direction: column;
			display: flex;
			.name{
				font-size: 14px;
				line-height: 1.3;
			}
		}
		.release_time{
			margin-top: 7px;
		}
	}
</style>
